module.exports = __webpack_public_path__ + "img/resource-empty.07d8bc6b.png";